import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { CheckInTimeRenderer } from 'timeSheet/components/CellRenderers';

const useCheckInColumn = ({
  updateCheckInTime,
  updateCheckOutTime,
  hasActionPermission,
  updateOSCheckInTime,
  updateOSCheckOutTime,
  allowUpdateExternal = false
}) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return CheckInTimeRenderer({
        rowData: params.data,
        columnData: {
          updateCheckInTime,
          updateCheckOutTime,
          updateOSCheckInTime: allowUpdateExternal ? updateOSCheckInTime : undefined,
          updateOSCheckOutTime: allowUpdateExternal ? updateOSCheckOutTime : undefined,
          readOnly: !hasActionPermission,
          onOutsideClickSave: true,
          allowUpdateExternal
        }
      });
    },
    [
      updateCheckInTime,
      updateCheckOutTime,
      updateOSCheckInTime,
      updateOSCheckOutTime,
      hasActionPermission,
      allowUpdateExternal
    ]
  );

  return useMemo(
    () => ({
      field: 'actualCheckIn',
      headerName: t('checkInTime'),
      sortable: true,
      width: 125,
      cellClass: 'justify-start',
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useCheckInColumn;
